import { Link } from "react-router-dom";
import '../assets/css/custom.css';
import whatsAppImg from '../assets/Images/whatsApp.png';

function Footer() {
  return (
    <div>
        <div className="bg-dark m-0 w-100 py-4">
            <div class="row w-100">
                <div class="col-md-4">
                    <div class="card bg-dark border-0">
                        <div class="card-body">
                            <h4 class="card-title text-light mb-2">Ezio Infotech</h4>
                            <hr className="w-25 text-light" />
                            <p class="card-text text-light">Success is no accident. It is hard work, perseverance, learning, studying, sacrifice and most of all, love of what you are doing or learning to do.</p>
                            <ul className="social-media list-unstyled p-0 d-flex align-items-center gap-4">
                                <li>
                                    <Link className="" to="/">
                                        <i class="fa-brands fa-twitter text-white fs-5"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="" to="/">
                                        <i class="fa-brands fa-facebook-f text-white fs-5"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="" to="/">
                                        <i class="text-white fa-brands fa-instagram fs-5"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card bg-dark border-0">
                        <div class="card-body">
                            <h4 class="card-title text-light mb-2">Quick Links</h4>
                            <hr className="w-25 text-light" />
                            <ul className="p-0">
                                <li className="nav-item mb-1">
                                <Link className="nav-link text-light" aria-current="page" to="/">Home</Link>
                                </li>
                                <li className="nav-item mb-1">
                                <Link className="nav-link text-light" to="/about">About</Link>
                                </li>
                                <li className="nav-item mb-1">
                                <Link className="nav-link text-light" to="/service">Service</Link>
                                </li>
                                <li className="nav-item mb-1">
                                <Link className="nav-link text-light" to="/product">Product</Link>
                                </li>
                                <li className="nav-item mb-1">
                                <Link className="nav-link text-light" to="/team">Team</Link>
                                </li>
                                <li className="nav-item mb-1">
                                <Link className="nav-link text-light" to="/blog">Blog</Link>
                                </li>
                                <li className="nav-item mb-1">
                                <Link className="nav-link text-light" to="/carrer">Carrer</Link>
                                </li>
                                <li className="nav-item mb-1">
                                <Link className="nav-link text-light" to="/contact">Contact</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card bg-dark border-0">
                        <div class="card-body">
                            <h3 class="card-title text-light mb-2">Have a Questions?</h3>
                            <hr className="w-25 text-light" />
                            <div className="d-flex gap-4">
                                <i class="text-light fs-5 fa-solid fa-location-dot"></i>
                                <p className="text-light">NEBC CORNER Office No 309 Second Floor Near Savata Maharaj Mandir, Aher Wadi Chowk, Jadhavwadi Pune 412114</p>
                            </div>
                            <div className="mb-3">
                                <iframe _ngcontent-ng-c2151868728="" src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120954.2961507051!2d73.74129376963074!3d18.67199292818292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bc2b94df1eecb2b%3A0x2416a05fa66b065b!2sOffice%20No%20309%20Second%20Floor%2C%20NEBC%20CORNER%2C%20Aher%20Wadi%20Chowk%2C%20near%20Savata%20Maharaj%20Mandir%2C%20Jadhavwadi%2C%20Chikhli%2C%20Pune%2C%20Pimpri-Chinchwad%2C%20Maharashtra%20411062!3m2!1d18.6720109!2d73.8236955!5e0!3m2!1sen!2sin!4v1762231897077!5m2!1sen!2sin" width="100%" height="150" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" style={{border:" 0;"}}></iframe>
                            </div>
                            <div className="d-flex gap-4 mb-3">
                                <i class="fs-5 text-light fa-solid fa-phone"></i>
                                <a className="text-light text-decoration-none" href="tel:+919960588439">+91 99605 88439</a>
                            </div>
                            <div className="d-flex gap-4">
                                <i class="fs-5 text-light fa-solid fa-envelope"></i>
                                <a className="text-light text-decoration-none" href="mailto:ravindra.chaudhari@ezioinfotech.com">ravindra.chaudhari@ezioinfotech.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-100 p-0 m-0 bg-white" style={{height:"2px"}}></div>
            <div className="mt-4">
                <p className="text-center text-white">
                    Copyright © 2024 All rights reserved | Designed By 
                    <a className="text-decoration-none fw-semibold text-warning" href="https://ezioinfotech.com/"> Ezio Infotech Pvt.Ltd</a>
                </p>
            </div>
        </div>   
        

        {/* WhatsApp icon */}
        <a href="https://wa.me/919960588439" id="whatsapp-icon">
            <img src={whatsAppImg} style={{width: "100%", borderRadius: "50%"}} />
        </a>
    </div>
  );
}

export default Footer;